import GetStarted from 'src/app/dashboardv2/getStarted'
import InstitutionProfile from 'src/app/dashboardv2/institutionProfile'
import InstitutionBranding from 'src/app/dashboardv2/institutionBranding'
import SetupSuccess from 'src/app/dashboardv2/setupSuccess'
import InviteTeam from 'src/app/dashboardv2/inviteTeam'
import BusinessLogic from 'src/app/dashboardv2/businessLogic'
import InstitutionCreation from 'src/app/dashboardv2/InstitutionCreation'
import SupportManagement from 'src/app/dashboardv2/supportManagement'
import UserProfile from 'src/app/dashboardv2/userProfile'
import HelpAndResources from 'src/app/dashboardv2/helpAndResourses'
import InstitutionList from "src/app/dashboardv2/InstitutionList"
import InstitutionDetails from 'src/app/dashboardv2/InstitutionCreation/InstitutionDetails'
import InstitutionConfiguration from 'src/app/dashboardv2/InstitutionCreation/InstitutionConfiguration'
import AppGeneration from 'src/app/dashboardv2/appGeneration'
import AutoDeployment from 'src/app/dashboardv2/autoDeployment'
import FeedNotification from 'src/app/dashboardv2/feedNotification'
import TeamMembers from 'src/app/dashboardv2/teamMembers'
import RolesAndPermission from 'src/app/dashboardv2/rolesAndPermission'
import Home from 'src/app/dashboardv2/home'
import AuditTrails from 'src/app/dashboardv2/auditTrails'
import {
    CustomerListRoute,
    CbpCustomerListRoute,
    AccountUpgradeRoute,
} from 'src/app/dashboardv2/customerManagement/routes'
import SurveyManagement from 'src/app/dashboardv2/surveyManagement'
import SurveyDetails from 'src/app/dashboardv2/surveyDetails'
import SurveyReport from 'src/app/dashboardv2/surveyReport'

export default [
    GetStarted,
    InstitutionProfile,
    InstitutionBranding,
    SetupSuccess,
    InviteTeam,
    BusinessLogic,
    InstitutionCreation,
    SupportManagement,
    UserProfile,
    HelpAndResources,
    InstitutionList,
    InstitutionDetails,
    InstitutionConfiguration,
    AppGeneration,
    AutoDeployment,
    FeedNotification,
    TeamMembers,
    RolesAndPermission,
    Home,
    AuditTrails,
    CustomerListRoute,
    CbpCustomerListRoute,
    AccountUpgradeRoute,
    SurveyManagement,
    SurveyDetails,
    SurveyReport,
]